import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import {
  httpGet,
  httpPost,
  httpPut,
  httpDelete,
} from "../../utility/requestHelper";
import { unifiedEnvConfig } from "../../constants/api-endpoint";
import { DashboardNameModal } from "./DashboardNameModal";
import { useSelector } from "react-redux";
import { DASHBOARD_MESSAGES, DATE_FORMATS } from "../../constants/app-constant";
import { DASHBOARD_CONTAINER } from "../../constants/route-constants";
import {
  DeleteIcon,
  EditIcon,
  NoFeedIcon,
  AddWidgetIcon,
  MenuIcon,
} from "../Icons/icons.component";
import {
  formatDate,
  formatDateTime,
  getUniqueValuesFromList,
} from "../../utility/common-methods";
import Loader from "rsuite/Loader";
import { ConfirmModal } from "../Shared/Modal/ConfirmModal";
import "../../components/Topics/topics.sass";
import ConceptLogo from "../../assets/images/conceptbiu-logo.png";

const getLocalizedTime = (ts) => {
  try {
    return moment(ts).format(DATE_FORMATS.DT_DDMMYYYY_dash);
  } catch (e) {
    return "";
  }
};

export default function DashboardList() {
  const [limit, setLimit] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [openEditModal, setEditModal] = useState(false);
  const [openDeleteModal, setDeleteModal] = useState(false);
  const [editData, setEditId] = useState({
    editId,
    name,
  });
  const [dashboardsList, setDashboardsList] = useState([]);
  const [dashboardNameStatus, setDashboardNameStatus] = useState("");
  const [loader, setLoader] = useState(true);
  const [paginationData, setPaginationData] = useState({});
  const history = useHistory();
  const { DDMMYYYY_dash } = DATE_FORMATS;

  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};

  useEffect(() => {
    if (selectedClient && selectedClient.id) {
      fetchDashboardsList();
    }
  }, [limit, selectedClient]);

  const { editId, name } = editData;

  const fetchDashboardsList = () => {
    const perPage = 20;
    const page = limit;

    setLoader(true);
    httpGet(
      `${unifiedEnvConfig.GET_DASHBOARDS_LIST}?client_id=${selectedClient.id}&perPage=${perPage}&page=${page}`
    )
      .then((response) => {
        setLoader(false);
        const { status, data, pagination } = response.data;
        setPaginationData(pagination);
        if (status === 200) {
          if (limit !== 1) {
            setDashboardsList(
              getUniqueValuesFromList([...dashboardsList, ...data], "id")
            );
          } else {
            setDashboardsList(data);
          }
        }
      })
      .catch((e) => {
        setLoader(false);
        return e;
      });
  };

  function onCancelModalClick() {
    setOpenModal(false);
    setEditModal(false);
    setDeleteModal(false);
    setEditId({
      editId,
      name,
    });
  }

  function handleMoreClick() {
    if (paginationData.total != dashboardsList.length) {
      setLimit(limit + 1);
    }
  }

  const onConfirmName = (e, name) => {
    const { ERROR_OCCURED, NAME_REQUIRED } = DASHBOARD_MESSAGES;
    if (name) {
      httpPost(
        `${unifiedEnvConfig.ADD_DASHBOARD_NAME}?client_id=${selectedClient.id}`,
        {
          name,
        }
      )
        .then((response) => {
          if (response.data.status === 201) {
            setOpenModal(false);
            setDashboardNameStatus("");
            fetchDashboardsList();
            setLimit(1);
          }
        })
        .catch((err) => {
          setDashboardNameStatus(ERROR_OCCURED);
        });
    } else {
      setDashboardNameStatus(NAME_REQUIRED);
    }
  };

  const onConfirmEditName = (e, name) => {
    const { ERROR_OCCURED, NAME_REQUIRED } = DASHBOARD_MESSAGES;
    if (name) {
      httpPut(
        `${unifiedEnvConfig.ADD_DASHBOARD_NAME}/${editId}?client_id=${selectedClient.id}`,
        {
          name,
        }
      )
        .then((response) => {
          if (response.data.status === 200) {
            setEditModal(false);
            setDashboardNameStatus("");
            fetchDashboardsList();
            setLimit(1);
          }
        })
        .catch((err) => {
          setDashboardNameStatus(ERROR_OCCURED);
          setEditModal(false);
        });
    } else {
      setDashboardNameStatus(NAME_REQUIRED);
    }
  };

  const onConfirmDeleteName = (e) => {
    const { ERROR_OCCURED } = DASHBOARD_MESSAGES;
    httpDelete(
      `${unifiedEnvConfig.ADD_DASHBOARD_NAME}/${editId}?client_id=${selectedClient.id}`
    )
      .then((response) => {
        if (response.status === 204) {
          setDeleteModal(false);
          setDashboardsList(dashboardsList.filter((i) => i.id != editId));
          fetchDashboardsList();
          setLimit(1);
        }
      })
      .catch((err) => {
        setDashboardNameStatus(ERROR_OCCURED);
        setDeleteModal(false);
      });
  };

  const handleDashboardNameClick = (e, row) => {
    e.preventDefault();
    history.push({
      pathname: `${DASHBOARD_CONTAINER}/${row.id}`,
      data: dashboardsList,
    });
  };

  const handleEditClick = (e, id, name) => {
    e.stopPropagation();
    setEditModal(true);
    setEditId({ name, editId: id });
  };

  const handleDeleteClick = (e, id) => {
    e.stopPropagation();
    setDeleteModal(true);
    setEditId({ editId: id });
  };

  return (
    <>
      <div className={`mainContainer dashboardListingContainer`}>
        <div className="dashboardHeader">
          <div className="dashboardHeaderTop d-flex">
            <div className="dashboardMobileMenu">
              <button className="btn menuBtn" id="menuBtn">
                <MenuIcon />
              </button>
              <img src={ConceptLogo} width="32" height="32" />
            </div>
            <div className="dhLeft d-flex">
              <div className="dhLeftWrap">
                <h1>Dashboard</h1>
              </div>
            </div>
            <div className="dhRight d-flex">
              <button
                className="btn btnBlue dashboardHeaderListBtn"
                onClick={() => setOpenModal(true)}
              >
                <AddWidgetIcon /> <span>Add Dashboard</span>
              </button>
            </div>
          </div>
        </div>
        {openModal ? (
          <DashboardNameModal
            show={openModal}
            onCancel={onCancelModalClick}
            modalTitle="Add Dashboard"
            confirmButtonText="Add Dashboard"
            onConfirm={onConfirmName}
            error={dashboardNameStatus}
            confirmText="Name"
          />
        ) : null}

        {openEditModal ? (
          <DashboardNameModal
            show={openEditModal}
            onCancel={onCancelModalClick}
            modalTitle="Rename Dashboard"
            confirmButtonText="Update"
            onConfirm={onConfirmEditName}
            error={dashboardNameStatus}
            confirmText="Name"
            editValue={editData}
          />
        ) : null}

        {openDeleteModal ? (
          <ConfirmModal
            show={openDeleteModal}
            onCancel={onCancelModalClick}
            modalTitle="Delete Dashboard"
            confirmButtonText="Delete"
            confirmText="Are you sure you want to delete this Dashboard?"
            onConfirm={onConfirmDeleteName}
          />
        ) : null}

        {dashboardsList && dashboardsList.length ? (
          <>
            <div className="table-responsive">
              <table className="table customTableTwo dashboardListingTable">
                <thead>
                  <tr>
                    <th className="thName">Name</th>
                    <th className="thDateAdded">Date Added</th>
                    <th className="thLastUpdated">Last Updated</th>
                    <th className="thAction">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {dashboardsList.map((row) => {
                    const { id, name, created_at, updated_at } = row || {};
                    return (
                      <tr
                        onClick={(e) => handleDashboardNameClick(e, row)}
                        key={id}
                      >
                        <td className="thName">
                          <strong>{name}</strong>
                        </td>
                        <td className="thDateAdded">
                          {formatDate(created_at, DDMMYYYY_dash)}
                        </td>
                        <td className="thLastUpdated">{`${getLocalizedTime(
                          updated_at
                        )}`}</td>
                        <td className="thAction">
                          <span
                            className="actionLink edit"
                            onClick={(e) => handleEditClick(e, id, name)}
                          >
                            <div className="hasTooltip">
                              <EditIcon />
                              <span className="tooltipWrap center">Edit</span>
                            </div>
                          </span>
                          <span
                            className="actionLink delete"
                            onClick={(e) => handleDeleteClick(e, id)}
                          >
                            <div className="hasTooltip">
                              <DeleteIcon />
                              <span className="tooltipWrap center">Delete</span>
                            </div>
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            {paginationData.page != paginationData.pages && (
              <div className="viewMoreBtnWrap">
                {loader ? (
                  <Loader />
                ) : (
                  <button
                    className="btn btnBlue viewMoreBtn"
                    onClick={() => handleMoreClick()}
                  >
                    View More
                  </button>
                )}
              </div>
            )}
          </>
        ) : null}
        {dashboardsList.length == 0 && !loader ? (
          <div className="noFilterDataWrap">
            <NoFeedIcon />
            <h6>No Dashboards Found</h6>
            <p>Please create a dashboard to add widgets</p>
          </div>
        ) : null}
      </div>
    </>
  );
}
